import React from "react";

import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

interface ISortableItem {
  no: string | number;
}

interface IProps<T extends ISortableItem> {
  item: T;
  format: (item: T) => React.ReactNode;
  onClick?: (item: T) => void;
}

export default function SortableRow<T extends ISortableItem>({
  item,
  format,
  onClick,
}: IProps<T>) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} =
    useSortable({
      id: item.no,
    });

  return (
    <tr
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
      }}
      onClick={() => onClick?.(item)}>
      <td
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}>
        <button
          type="button"
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
          }}>
          ☰
        </button>
      </td>

      {format(item)}
    </tr>
  );
}
